const staticData = Object.freeze({
	politicsLink: '/upload/Personal.pdf',
	personalLink: '/upload/policy.pdf'
})

export default staticData;
